// extracted by mini-css-extract-plugin
module.exports = {"footer":"footer-3danb_vo","foot_link":"foot_link-394rj3QP","list":"list-2wA1DPTr","link":"link-3O9kFYoW","copyright":"copyright-2fOb5LwI"};